import { Controller } from '@hotwired/stimulus'
import Tab from 'bootstrap/js/src/tab'

export default class extends Controller {
  connect () {
    this._addButtonsAttributes()
    this.tabs = this.buttonTargets.map((button) => {
      return new Tab(button)
    })
  }

  disconnect () {
    this.tabs.forEach(c => c.dispose())
  }

  // show by event listener on `document` (Data API implementation)
  // set when importing bs module https://github.com/twbs/bootstrap/blob/v5.3.8/js/src/tab.js#L285
  // show () { }

  // adds: 'data-bs-toggle', 'data-bs-target'
  _addButtonsAttributes () {
    this.buttonTargets.forEach((btn, idx) => {
      btn.setAttribute("data-bs-toggle", "tab")
      btn.setAttribute("data-bs-target", `#${btn.getAttribute("aria-controls")}`)
    })
  }
}
